import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import DirectionItem from './DirectionItem'
import './Page4-directions.css'

const Page4 = () => {
  const { mainGoal, directionItems, isNoDirections } = useSelectReportData()
  const mainGoalTitle = mainGoal?.title || ''

  if (isNoDirections) {
    return null
  }

  return (
    <div style={{ padding: '40px 15px 50px 15px' }}>
      <p
        className='description-sub'
        style={{ fontSize: '0.8rem' }}
      >
        Your initial and main goal
      </p>
      <p className='subtitle'>{mainGoalTitle}</p>
      <p
        className='description-sub'
        style={{ marginTop: 0 }}
      >
        To achieve this goal, please pay attention to the following improvements which will help you:
      </p>
      {directionItems.map((directionItem, key) => {
        return (
          <DirectionItem
            {...directionItem}
            key={key}
          />
        )
      })}
    </div>
  )
}

export default Page4
